module.exports = __webpack_public_path__ + "static/img/header-right.d449d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-right.png
// module id = cTM8
// module chunks = 2